import axiosInstance from "@/composables/axios-instance";
import { toast } from "vue3-toastify";

const state = {
  requestsList: [],
  myRequestsList: [],
  requestItemsList: [],
  requestDetail: [],
  requestPrice: [],
};

const getters = {
  getRequestsList(state) {
    return state.requestsList;
  },
  getMyRequestsList(state) {
    return state.myRequestsList;
  },
  getRequestItemsList(state) {
    return state.requestItemsList;
  },
  getRequestDetail(state) {
    return state.requestDetail;
  },
  getRequestPrice(state) {
    return state.requestPrice;
  },
};

const mutations = {
  setRequestsList(state, list) {
    state.requestsList = list;
  },
  setMyRequestsList(state, list) {
    state.myRequestsList = list;
  },
  setRequestItemsList(state, list) {
    state.requestItemsList = list;
  },
  setRequestDetail(state, detail) {
    state.requestDetail = detail;
  },
  setRequestPrice(state, price) {
    state.requestPrice = price;
  },
};

const actions = {
  getRequestsListFromApi({ commit }, filter) {
    let requestData = {};
    for (let key in filter) {
      if (filter[key]) {
        requestData[key] = filter[key];
      }
    }
    return axiosInstance
      .post("/request/report/", requestData, { params: { page_size: 20, page: filter.page, date_range: filter.date_range } })
      .then((response) => {
        commit("setRequestsList", response.data);
      })
      .catch((error) => {
        toast.error("لیست درخواست‌ها دریافت نشد لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },

  getMyRequestsListFromApi({ commit }, filter) {
    let requestData = {};
    for (let key in filter) {
      if (filter[key]) {
        requestData[key] = filter[key];
      }
    }
    return axiosInstance
      .post("/request/my/report/", requestData)
      .then((response) => {
        commit("setMyRequestsList", response.data);
      })
      .catch((error) => {
        toast.error("لیست درخواست‌ها دریافت نشد لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },

  /* eslint-disable */
  createRequestItem({ }, { item, username }) {
    let requestData = {};
    for (let key in item) {
      requestData[key] = item[key];
    }
    return axiosInstance
      .post("/request/item/create/", requestData, {
        params: {
          username,
        },
      })
      .then((response) => {
        toast.success("کالا با موفقیت به درخواست افزوده شد");
      })
      .catch((error) => {
        console.error(error);
        toast.error("کالا به درخواست افزوده نشد لطفا بعدا تلاش کنید");
      });
  },
  deleteRequest({ }, id) {
    return axiosInstance
      .delete("/request/delete/", { params: { id } })
      .then((response) => {
        toast.success("درخواست با موفقیت حذف شد");
      })
      .catch((error) => {
        toast.error("متاسفانه درخواست حذف نشد. لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },
  getRequestItemsFromApi({ commit }, username) {
    return axiosInstance
      .post("/request/item/report/", null, { params: { username } })
      .then((response) => {
        commit("setRequestItemsList", response.data);
      })
      .catch((error) => {
        toast.error("مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },
  createRequest({ }, { request, username }) {
    let requestData = {};
    for (let key in request) {
      requestData[key] = request[key];
    }
    /* eslint-disable */
    return axiosInstance
      .post("/request/create/", requestData, { params: { username } })
      .then((response) => {
        toast.success("درخواست با موفقیت ایجاد شد");
      })
      .catch((error) => {
        console.error(error);
        toast.error("درخواست ساخته نشد لطفا بعدا تلاش کنید");
      });
  },
  updateRequest({ }, request) {
    let requestData = {};
    for (let key in request) {
      if (key != "id") requestData[key] = request[key];
    }

    return axiosInstance
      .put("/request/update/", requestData, { params: { id: request.id } })
      .then((response) => {
        toast.success("اطلاعات درخواست با موفقیت تغییر یافت");
      })
      .catch((error) => {
        toast.error("متاسفانه اطلاعات تغییر نیافت لطفا بعدا تلاش کنید");
      });
  },
  deleteRequestItem({ }, { id, username }) {
    return axiosInstance
      .delete("/request/item/delete/", { params: { id, username } })
      .then((response) => {
        toast.success("کالا با موفقیت از درخواست حذف شد.");
      })
      .catch((error) => {
        toast.error("متاسفانه کالا از درخواست حذف نشد لطفا بعدا تلاش کنید");
      });
  },
  updateRequestItem({ }, { item, username }) {
    let requestData = {};
    for (let key in item) {
      if (key != "id") {
        requestData[key] = item[key];
      }
    }

    return axiosInstance
      .put("/request/item/update/", requestData, {
        params: { id: item.id, username },
      })
      .then((response) => {
        toast.success("مشخصات درخواست با موفقیت تغییر یافت");
      })
      .catch((error) => {
        toast.error("درخواست شما تغییر نیافت لطفا بعدا تلاش کنید.");
      });
  },
  getRequestDetailFromApi({ commit }, id) {
    return axiosInstance
      .get("/request/detail/", { params: { id } })
      .then((response) => {
        commit("setRequestDetail", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  updateRequestDetailItem({ }, data) {
    return axiosInstance
      .put(
        "/request/item/update/delivery",
        {
          id: data.id,
          count_delivered: data.count_delivered,
          status: data.status,
        },
      )
      .then((response) => {
        toast.success("وضعیت با موفقیت تغییر یافت");
      })
      .catch((error) => {
        toast.error("وضعیت تغییر نیافت لطفا بعدا تلاش کنید");
      });
  },

  updateRequestDetailItems({ }, data) {
    let request = [];
    for (let i = 0; i < data.length; i++) {
      request.push(
        {
          id: data[i].id,
          count_delivered: data[i].count_delivered,
          status: data[i].status,
        },
      )
    }
    return axiosInstance
      .put(
        "/request/items/update/delivery",
        request
      )
      .then((response) => {
        toast.success("وضعیت با موفقیت تغییر یافت");
      })
      .catch((error) => {
        toast.error("وضعیت تغییر نیافت لطفا بعدا تلاش کنید");
      });
  },

  getPriceOfRequest({ commit }, id) {
    return axiosInstance
      .get("/request/item/report/delivery", {
        params: {
          id,
        },
      })
      .then((response) => {
        commit("setRequestPrice", response.data);
      })
      .catch((error) => {
        toast.error("متاسفانه اطلاعات قیمتی دریافت نشد");
        console.error(error);
      });
  },
  getRequestsExcel() {
    return axiosInstance
      .get("/request/excel/", {
        responseType: "blob"
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const filename = "Requests List.xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error:", error));
  },
  returnBackProduct({ commit }, returnData) {
    return axiosInstance
      .put("/request/item/return/", {
        count_return: returnData.count_return
      },
        {
          params: { id: returnData.id }
        })
      .then((response) => {
        toast.success("کالا با موفقیت مرجوع شد.");
      })
      .catch((error) => {
        toast.error("کالا مرجوع نشد لطفا بعدا تلاش کنید.");
        console.error(error);
      })
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
